// Validation utility functions for questionnaire form

export const validateForm = (formData, fotoSuratKepemilikanTanah = null, fotoKK = null) => {
  const newErrors = {};
  
  // Validasi field required
  const requiredFields = [
    { field: "namaKepalaKeluarga", number: 1, label: "Nama Kepala Keluarga" },
    { field: "nomorKK", number: 2, label: "Nomor KK" },
    { field: "nik", number: 3, label: "NIK" },
    { field: "alamat", number: 4, label: "Alamat" },
    { field: "kecamatan", number: 5, label: "Kecamatan" },
    { field: "desaKelurahan", number: 6, label: "Desa/Kelurahan" },
    { field: "rumahTinggalSendiri", number: 7, label: "Status Rumah Tinggal" },
    { field: "statusKeluarga", number: 8, label: "Status Keluarga" },
    { field: "usiaPernikahan", number: 9, label: "Usia Pernikahan" },
    { field: "StatusKepemilikanTanah", number: 10, label: "Status Kepemilikan Tanah" },
    { field: "apakahLokasiTanahSesuaiRTRW", number: 11, label: "Kesesuaian Lokasi Tanah dengan RTRW" },
    { field: "tingkatPenghasilanKeluarga", number: 12, label: "Tingkat Penghasilan Keluarga" },
    { field: "jumlahPenghuniRumah", number: 13, label: "Jumlah Penghuni Rumah" },
  ];

  // Validasi field required tidak boleh kosong
  requiredFields.forEach(({ field, number, label }) => {
    if (!formData[field] || formData[field].toString().trim() === "") {
      newErrors[field] = `(${number}) ${label} wajib diisi`;
    }
  });

  // Validasi panjang nomor KK (16 digit)
  if (formData.nomorKK && formData.nomorKK.toString().trim() !== "") {
    const nomorKK = formData.nomorKK.toString().replace(/\s/g, '');
    if (nomorKK.length !== 16) {
      newErrors.nomorKK = "(2) Nomor KK harus terdiri dari 16 digit.";
    } else if (!/^\d+$/.test(nomorKK)) {
      newErrors.nomorKK = "(2) Nomor KK harus berupa angka.";
    }
  }

  // Validasi panjang NIK (16 digit)
  if (formData.nik && formData.nik.toString().trim() !== "") {
    const nik = formData.nik.toString().replace(/\s/g, '');
    if (nik.length !== 16) {
      newErrors.nik = "(3) Nomor KTP harus terdiri dari 16 digit.";
    } else if (!/^\d+$/.test(nik)) {
      newErrors.nik = "(3) Nomor KTP harus berupa angka.";
    }
  }

  // Validasi Status Kepemilikan Tanah Lainnya
  if (formData.StatusKepemilikanTanah === "Lainnya" && 
      (!formData.StatusKepemilikanTanahLainnya || formData.StatusKepemilikanTanahLainnya.trim() === "")) {
    newErrors.StatusKepemilikanTanahLainnya = "Harap tulis status kepemilikan tanah lainnya";
  }

  // Validasi foto surat kepemilikan tanah
  if (formData.StatusKepemilikanTanah === "Milik Sendiri,Ada dokumen sah" && !fotoSuratKepemilikanTanah) {
    newErrors.fotoSuratKepemilikanTanah = "Foto surat kepemilikan tanah wajib diupload untuk status Milik Sendiri";
  }

  // Validasi koordinat (salah satu harus diisi)
  if (!formData.titikKoordinatRumah && !formData.manualTitikKoordinatRumah) {
    newErrors.titikKoordinatRumah = "Koordinat rumah wajib diisi (gunakan GPS atau input manual)";
  }

  // Validasi foto KK
  if (!fotoKK) {
    newErrors.fotoKK = "Foto KK wajib diupload";
  }

  return newErrors;
};

export const validateCoordinate = (coordinate) => {
  if (!coordinate || coordinate.trim() === "") return false;
  
  const regex = /^-?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*-?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)$/;
  return regex.test(coordinate);
};